(function (upp) {
    'use strict';

    upp.directive('notification', [function () {
        return {
            restrict: 'E',
            scope: {
                model: '='
            },
            replace: true,
            templateUrl: require('../templates/single-notification.html'),
            controller: ['$rootScope', '$scope', '$sce', 'notificationsService', 'appi', function ($rootScope, $scope, $sce, notificationsService, appi) {

                $scope.time = new Date($scope.model.created);
                // FIXME: On iOS sometimes the timestamp is not correct
                if ($scope.time.getFullYear() === 1970) {
                    $scope.time = new Date($scope.model.created * 1000);
                }

                if ($scope.model.title) {
                    $scope.model.title = $sce.trustAsHtml($scope.model.title);
                }

                var bodyParse = notificationsService.parseMessage($scope.model.alert);
                $scope.model.alert = $sce.trustAsHtml(bodyParse);

                $scope.open = function () {
                    appi.ui.modalMessage({
                        title: $scope.model.title,
                        img: $scope.model.icon,
                        message: bodyParse,
                        closeButton: {
                            text: "CLOSE"
                        }
                    }).then((modal) => {
                        modal.show();
                    })
                };
            }]
        };
    }]);

}(upp));



// WEBPACK FOOTER //
// ./src/app/modules/notifications/directives/notification-directive.js